module.exports = __webpack_public_path__ + "media/images/font/Gustavo-ThinItalic-a5377f0bedaeac230ccc476b8f66afb8.eot";